import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { COMPANY } from "@/lib/site";

const VALUES = [
  ["Container-only", "We work in full containers so every order gets its own packing run and cold chain."],
  ["Graded at source", "Fruit is sorted, graded and packed close to the farms to keep transit time short."],
  ["One point of contact", "The person who quotes you is the person who follows your shipment."],
];

export default function About() {
  return (
    <>
      <Seo title="About" description="About SLN Agro Exports, an Indian exporter of fresh bananas, red onions and pomegranates." path="/about" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-7 space-y-6">
          <p className="text-xs uppercase tracking-[0.25em] text-emerald-800">About us</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">Fresh produce from Indian farms to your port.</h1>
          <p className="text-stone-600 leading-relaxed">
            SLN Agro Exports supplies G9 bananas, red onions and Bhagwa pomegranates to importers and distributors. We focus on a few products so we can handle sourcing, grading, packing and shipping documents with care.
          </p>
          <p className="text-stone-500 leading-relaxed border-l-2 border-amber-600 pl-4" data-testid="about-placeholder">
            [Add your story here: founding year, who runs the company, the farms and packhouses you work with, and the markets you already ship to.]
          </p>
          <dl className="grid sm:grid-cols-2 gap-6 pt-4 text-sm" data-testid="about-registration">
            <div><dt className="text-stone-500">Legal name</dt><dd className="font-medium">{COMPANY.legalName}</dd></div>
            <div><dt className="text-stone-500">APEDA registration</dt><dd className="font-medium">{COMPANY.apeda}</dd></div>
            <div><dt className="text-stone-500">IEC</dt><dd className="font-medium">{COMPANY.iec}</dd></div>
            <div><dt className="text-stone-500">Registered office</dt><dd className="font-medium">{COMPANY.address}</dd></div>
          </dl>
        </div>
        <div className="md:col-span-5">
          <img src="/img/farm.jpg" alt="Green bananas on the plant" className="rounded-lg w-full aspect-[3/4] object-cover" />
        </div>
      </section>
      <section className="bg-white border-y border-stone-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-3 gap-10">
          {VALUES.map(([t, d]) => (
            <div key={t} className="space-y-3">
              <h3 className="text-xl font-semibold text-emerald-900">{t}</h3>
              <p className="text-stone-600 text-sm leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <Link to="/request-quote" data-testid="about-quote-btn" className="rounded-full bg-emerald-900 hover:bg-emerald-800 text-white px-7 py-3.5 font-medium transition-colors">Talk to us about an order</Link>
      </section>
    </>
  );
}
